import React, { useState } from 'react';
import { EMAIL_DE_CONTATO } from '../../config/contato';
import { apiFetch } from '../../config/api';
import { useIdioma } from '../../i18n';
import '../../styles/Contato.css';

/**
 * O contato: uma pergunta, o campo da mensagem em destaque e o envio.
 * O id continua `contact` porque o Header, o Footer e a tela de planos levam a `/#contact`.
 */
const Contato = () => {
  const { t } = useIdioma();
  const [form, setForm] = useState({ name: '', email: '', message: '' });
  const [status, setStatus] = useState(null); // { ok: bool, text: string }
  const [sending, setSending] = useState(false);

  const change = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  /* shortcut: cópia do envio de components/ContactForm.js, que segue servindo
     a Home antiga enquanto ela existir. Lá estão os porquês: `apiFetch` leva o
     Accept-Language, e `/send-email` é a rota pública (a `/contact` exige sessão). */
  const submit = async (e) => {
    e.preventDefault();
    setSending(true);
    setStatus(null);
    try {
      const res = await apiFetch('/send-email', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(form)
      });
      if (!res.ok) throw new Error('request failed');
      window.dataLayer.push({ event: 'generate_lead' });
      setStatus({ ok: true, text: 'inicio.contato.enviada' });
      setForm({ name: '', email: '', message: '' });
    } catch {
      setStatus({ ok: false, text: 'inicio.contato.falhou' });
    } finally {
      setSending(false);
    }
  };

  return (
    <section className="contato" id="contact" aria-labelledby="contato-titulo">
      <div className="nh-grade">
        <div className="contato-coluna">
          <h2 id="contato-titulo" data-r>{t('inicio.contato.titulo')}</h2>
          <p className="contato-chamada" data-r style={{ '--i': 1 }}>{t('inicio.contato.chamada')}</p>

          <form className="contato-form" onSubmit={submit} data-r style={{ '--i': 2 }}>
            <label className="contato-inteiro">
              {t('inicio.contato.mensagem')}
              <textarea
                name="message"
                rows="4"
                placeholder={t('inicio.contato.mensagemExemplo')}
                value={form.message}
                onChange={change}
                required
              />
            </label>
            <label>
              {t('inicio.contato.nome')}
              <input name="name" type="text" autoComplete="name" value={form.name} onChange={change} required />
            </label>
            <label>
              {t('inicio.contato.email')}
              <input
                name="email"
                type="email"
                autoComplete="email"
                placeholder={t('inicio.contato.emailExemplo')}
                value={form.email}
                onChange={change}
                required
              />
            </label>

            {status && (
              <p className={`contato-status ${status.ok ? '' : 'is-erro'}`.trim()} role="status">
                {t(status.text)}
              </p>
            )}

            <div className="contato-envio">
              <p>
                {t('inicio.contato.ouEscreva')} <a href={`mailto:${EMAIL_DE_CONTATO}`}>{EMAIL_DE_CONTATO}</a>
              </p>
              <button type="submit" className="sp-btn sp-btn-on-section nh-btn" disabled={sending}>
                {sending ? t('inicio.contato.enviando') : t('inicio.contato.enviar')}{' '}
                <span className="nh-seta" aria-hidden="true">→</span>
              </button>
            </div>
          </form>
        </div>
      </div>
    </section>
  );
};

export default Contato;
